import { TrackEvent } from '../../enums/Content/TrackEvent';
import { UserActivityEvent } from '../../enums/UserActivity';
import EventsInterface from '../../graphql/Events/EventsInterface';
import TrackInterface from '../../graphql/Rooms/TrackInterface';

export default class DownloadTracker {
  private contentId: string;

  private contactId?: string;

  private roomId?: string;

  private version?: number;

  constructor(
    contentId: string,
    contactId?: string,
    roomId?: string,
    version?: number
  ) {
    this.contentId = contentId;
    this.contactId = contactId;
    this.roomId = roomId;
    this.version = version;
  }

  public track(isGuestVisitor: boolean) {
    if (isGuestVisitor) {
      return this.trackGuestDownload();
    }

    this.trackInternalUserDownload();
  }

  /**
   * For authenticated non-guest visitors (e.g. admin/salespeople visiting
   * external rooms), the download is tracked via a custom event instead of
   * a room tracking event. This is counted for their personal user activity.
   */
  private trackInternalUserDownload() {
    try {
      new EventsInterface().create({
        event: UserActivityEvent.ContentDownloaded,
        meta: { contentId: this.contentId, version: this.version },
      });
    } catch (e) {
      // do nothing, as this isn't something of interest for users
    }
  }

  /**
   * For guests visitors, the download event is tracked via room analytics.
   * This is counted for the content downloads counter.
   */
  private trackGuestDownload() {
    if (!(this.roomId && this.version)) {
      return;
    }

    try {
      new TrackInterface(this.contactId).track({
        contentId: this.contentId,
        event: TrackEvent.DOWNLOAD,
        measure: 1,
        roomId: this.roomId,
        version: this.version,
      });
    } catch (e) {
      // do nothing, as this isn't something of interest for users
    }
  }
}
